const $ = jQuery.noConflict();
import 'select2/dist/js/select2.full.js';

'use strict';
const Select2 = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$select: $('.js-select'),
	$selectCf7: $('.js-select-cf7'),
	$selectCf7Apply: $('.js-select-cf7-apply'),
	$selectEvent: $('.js-events-filter'),
	$selectDisciplineSelect: $('.js-current-discipline'),
	$selectEmploymentTypeSelect: $('.js-current-employment-type'),
	$selectLocationSelect: $('.js-current-location'),

	/** @description Initialize */
	init: function() {
		this.select2();
		this.select2Cf7();
	},

	select2: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$select.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class'
		});
	},

	select2Cf7: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$selectCf7.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class',
		});

		Select2.$selectCf7Apply.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'apply-form-options',
		});

		Select2.$selectEvent.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'select-dropdown',
		});

		Select2.$selectDisciplineSelect.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'select-dropdown',
			placeholder: 'Discipline',
			allowClear: true
		});

		Select2.$selectEmploymentTypeSelect.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'select-dropdown',
			placeholder: 'Employment Type',
			allowClear: true
		});


		Select2.$selectLocationSelect.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'select-dropdown',
			placeholder: 'Location',
			allowClear: true
		});

		setTimeout(() => {
			$('.js-select-cf7 option:first-child').attr('disabled', true);
		}, 500);

		Select2.$selectCf7.on('select2:selecting', function() {
			$(this).removeClass('wpcf7-not-valid');
			$(this).siblings('.wpcf7-not-valid-tip').remove();
		});

		Select2.$selectCf7.on('change', function() {
			$(this).addClass('selected');
		});

		Select2.$selectCf7Apply.on('select2:selecting', function() {
			$(this).removeClass('wpcf7-not-valid');
			$(this).siblings('.wpcf7-not-valid-tip').remove();
		});

		Select2.$selectCf7Apply.on('change', function() {
			$(this).addClass('selected');
		});
	}
};

export default Select2;
